<template>
  <div>
    <div class="home" v-if="!isPad">
      <a-breadcrumb style="margin: 20px 0px 0 50px">
        <a-breadcrumb-item class="breadcrumb">
          <router-link :to="'/homePage/'">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item class="breadcrumb">
          <router-link :to="'/accompanyStudy/homeStudentsDraw/'">学生画像</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item class="breadcrumb">
          课程对比
        </a-breadcrumb-item>
      </a-breadcrumb>
      <div class="flex-row justify-between common-display-flex">
        <div class="class-detail common-flex-grow">

          <div class="class-option">
            <div class="justify-between ">
              <span class="ml-20">课程对比</span>
              <a-button class="classSpan" :loading="downBtnLoading" @click="downloadExcel">导出</a-button>
            </div>
            <a-divider/>
            <div class="flex-row mt-20">
              <span class="class-option-title pl-20">表现：</span>
              <span v-for="(item, index) in classType" @click="onTypeChange(index)" :key="index">
            <span :class="currentType==index?'classSpan':'classAct'">{{ item.name }}</span></span>
            </div>
            <div class="flex-row">
              <span class="class-option-title mt-20 pl-20">班级：</span>
              <div class="class-option-content mt-20" v-if="classShow">
                <a-checkbox-group :defaultValue="classCheckedList" @change="classChange">
                  <a-checkbox :value="item" v-for="item in classList" :key="item.id">
                    <a-tooltip placement="topLeft" :title="item.className">
                      {{ item.className }}
                    </a-tooltip>
                  </a-checkbox>
                </a-checkbox-group>
              </div>
            </div>
            <div class="flex-col">
              <div class="flex-row" v-show="currentType==1">
                <span class="class-option-title mt-10 pl-20">学生：</span>
                <div class="class-option-content mt-10" v-if="classShow">
                  <a-checkbox-group :defaultValue="studentsCheckedList" @change="studentChange">
                    <a-checkbox :value="item" v-for="item in studentListCheck" :key="item.userId||''">
                      <a-tooltip placement="topLeft" :title="item.userName">
                        {{ item.userName }}
                      </a-tooltip>
                    </a-checkbox>
                  </a-checkbox-group>
                  <span class="class-option-empty" v-show="studentListCheck.length==0">暂无学生</span>
                </div>
                <span class="class-option-more" v-show="false"
                      onclick="studentShowMore">显示更多</span>
              </div>
            </div>
            <div class="flex-row mt-10">
              <span class="class-option-title mt-10 pl-20">课程</span>
              <div class="class-option-content  ">
                <a-cascader
                    :field-names="{ label: 'displayName', value: 'id', children: 'subList' }"
                    :options="options"
                    expand-trigger="hover"
                    :display-render="displayRender"
                    placeholder="选择课程"
                    @change="onCascaderChange1"
                    style="width: 210px"
                />
                <a-cascader
                    :field-names="{ label: 'displayName', value: 'id', children: 'subList' }"
                    :options="options"
                    expand-trigger="hover"
                    placeholder="选择课程"
                    :display-render="displayRender"
                    @change="onCascaderChange2"
                    style="width: 210px;margin-left: 20px"
                />
                <a-cascader
                    :field-names="{ label: 'displayName', value: 'id', children: 'subList' }"
                    :options="options"
                    expand-trigger="hover"
                    placeholder="选择课程"
                    :display-render="displayRender"
                    @change="onCascaderChange3"
                    style="width: 210px;margin-left: 20px"
                />
                <a-cascader
                    :field-names="{ label: 'displayName', value: 'id', children: 'subList' }"
                    :options="options"
                    expand-trigger="hover"
                    placeholder="选择课程"
                    @change="onCascaderChange4"
                    :display-render="displayRender"
                    style="width: 210px;margin-left: 20px"
                />
                <a-cascader
                    :field-names="{ label: 'displayName', value: 'id', children: 'subList' }"
                    :options="options"
                    expand-trigger="hover"
                    placeholder="选择课程"
                    @change="onCascaderChange5"
                    :display-render="displayRender"
                    style="width: 210px;margin-left: 20px"
                />
              </div>
            </div>
          </div>
          <div class="class-behaves common-display-flex" v-show="currentType!=2">
            <div class="flex-col common-flex">
              <a-spin :spinning="main" :tip="tipsText">
                <div class="class-behave">
                  <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}被动行为</span>
                  <div class="flex-row justify-between ml-20 mr-20">
                    <div class="flex-col">
                      <span class="behave_title blue"> 阅读行为</span>
                      <span class="behave_content"> {{ readTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title green"> 听诵读</span>
                      <span class="behave_content">{{ radioTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title yellow"> 视频学习</span>
                      <span class="behave_content"> {{ videoTotal }}</span>
                    </div>
                  </div>
                  <div class="class-echarts" id="main" v-if="!mainEmpty"></div>
                  <a-empty v-if="mainEmpty"/>
                </div>
              </a-spin>
              <a-spin :spinning="create" :tip="tipsText">
                <div class="class-behave">
                  <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}构建行为</span>
                  <div class="flex-row justify-between ml-20 mr-20">
                    <div class="flex-col">
                      <span class="behave_title blue">任务活动数量</span>
                      <span class="behave_content">  {{ activityTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title green"> 任务活动获得星星数量</span>
                      <span class="behave_content"> {{ starTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title yellow"> 主观题数量</span>
                      <span class="behave_content">  {{ subjectiveTotal }}</span>
                    </div>
                  </div>
                  <div class="class-echarts" id="create" v-if="!createEmpty"></div>
                  <a-empty v-if="createEmpty"/>
                </div>

              </a-spin>
            </div>
            <div class="flex-col common-flex">
              <a-spin :spinning="positive" :tip="tipsText">
                <div class="class-behave ml-20">
                  <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}主动行为</span>
                  <div class="flex-row justify-between ml-20 mr-20">
                    <div class="flex-col">
                      <span class="behave_title blue"> 标注</span>
                      <span class="behave_content">  {{ dimensionTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title green"> 朗读</span>
                      <span class="behave_content"> {{ readingTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title yellow"> 完成客观题数量</span>
                      <span class="behave_content">  {{ objectiveTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title purple"> 正确客观题数量</span>
                      <span class="behave_content">  {{ objectiveCorrectTotal }}</span>
                    </div>
                  </div>
                  <div class="class-echarts" id="positive" v-if="!positiveEmpty"></div>
                  <a-empty v-if="positiveEmpty"/>
                </div>
              </a-spin>
              <a-spin :spinning="interaction" :tip="tipsText">
                <div class="class-behave ml-20">
                  <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}交互行为</span>
                  <div class="flex-row justify-between ml-20 mr-20">
                    <div class="flex-col">
                      <span class="behave_title blue"> 评论</span>
                      <span class="behave_content">  {{ commentTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title green"> 提问</span>
                      <span class="behave_content"> {{ askTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title yellow"> 点赞</span>
                      <span class="behave_content">  {{ praiseTotal }}</span>
                    </div>
                  </div>
                  <div class="class-echarts" id="interaction" v-if="!interactionEmpty"></div>
                  <a-empty v-if="interactionEmpty"/>
                </div>
              </a-spin>
            </div>
          </div>
          <div class="class-jiaohu flex-col" v-show="currentType==2">
            <div class="justify-between">
              <span>交互关系</span>
              <div class="classSpan">导出</div>
            </div>
            <div class="class-echarts-3" id="main1"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="phone" v-if="isPad">
      <a-breadcrumb style="margin: 20px 0px 0px 30px">
        <a-breadcrumb-item class="breadcrumb">
          <span @click="goHistory">学生画像</span>
        </a-breadcrumb-item>
        <a-breadcrumb-item class="breadcrumb">
          课程对比
        </a-breadcrumb-item>
      </a-breadcrumb>
      <div class="flex-row justify-between common-display-flex">
        <div class="class-detail common-flex-grow">

          <div class="class-option">
            <div class="justify-between ">
              <span class="ml-20">课程对比</span>
              <a-button class="classSpan" v-if="false" :loading="downBtnLoading" @click="enterDown">导出</a-button>
            </div>
            <a-divider/>
            <div class="flex-row mt-20">
              <span class="class-option-title pl-20">表现：</span>
              <span v-for="(item, index) in classType" @click="onTypeChange(index)" :key="index">
            <span :class="currentType==index?'classSpan':'classAct'">{{ item.name }}</span></span>
            </div>
            <div class="flex-row">
              <span class="class-option-title mt-20 pl-20">班级：</span>
              <div class="class-option-content mt-20" v-if="classShow">
                <a-checkbox-group :defaultValue="classCheckedList" @change="classChange">
                  <a-checkbox :value="item" v-for="item in classList" :key="item.id">
                    <a-tooltip placement="topLeft" :title="item.className">
                      {{ item.className }}
                    </a-tooltip>
                  </a-checkbox>
                </a-checkbox-group>
                <!-- <span class="lookAll" v-show="studentShow" @click="lookAllStudent">查看全部 ></span> -->
              </div>
            </div>
            <div class="flex-col">
              <div class="flex-row" v-show="currentType==1">
                <span class="class-option-title mt-10 pl-20">学生：</span>
                <div class="class-option-content mt-10" v-if="classShow">
                  <a-checkbox-group :defaultValue="studentsCheckedList" @change="studentChange">
                    <a-checkbox :value="item" v-for="item in studentListCheck" :key="item.userId||''">
                      <a-tooltip placement="topLeft" :title="item.userName">
                        {{ item.userName }}
                      </a-tooltip>
                    </a-checkbox>
                  </a-checkbox-group>
                  <span class="class-option-empty" v-show="studentListCheck.length==0">暂无学生</span>
                </div>
                <span class="class-option-more" v-show="false"
                      onclick="studentShowMore">显示更多</span>
              </div>
            </div>
            <div class="flex-row mt-10">
              <span class="class-option-title mt-10 pl-20 mr-20" style="white-space: nowrap">课程</span>
              <div class="class-option-content">
                <a-cascader
                    :field-names="{ label: 'displayName', value: 'id', children: 'subList' }"
                    :options="options"
                    expand-trigger="hover"
                    :display-render="displayRender"
                    placeholder="选择课程"
                    @change="onCascaderChange1"
                    style="width: 210px;margin-right: 10px;margin-bottom: 10px"
                />
                <a-cascader
                    :field-names="{ label: 'displayName', value: 'id', children: 'subList' }"
                    :options="options"
                    expand-trigger="hover"
                    placeholder="选择课程"
                    :display-render="displayRender"
                    @change="onCascaderChange2"
                    style="width: 210px;margin-right: 10px;margin-bottom: 10px"
                />
                <a-cascader
                    :field-names="{ label: 'displayName', value: 'id', children: 'subList' }"
                    :options="options"
                    expand-trigger="hover"
                    placeholder="选择课程"
                    :display-render="displayRender"
                    @change="onCascaderChange3"
                    style="width: 210px;margin-right: 10px;margin-bottom: 10px"
                />
                <a-cascader
                    :field-names="{ label: 'displayName', value: 'id', children: 'subList' }"
                    :options="options"
                    expand-trigger="hover"
                    placeholder="选择课程"
                    @change="onCascaderChange4"
                    :display-render="displayRender"
                    style="width: 210px;margin-right: 10px;margin-bottom: 10px"
                />
                <a-cascader
                    :field-names="{ label: 'displayName', value: 'id', children: 'subList' }"
                    :options="options"
                    expand-trigger="hover"
                    placeholder="选择课程"
                    @change="onCascaderChange5"
                    :display-render="displayRender"
                    style="width: 210px;margin-right: 10px;margin-bottom: 10px"
                />
              </div>
            </div>
          </div>
          <div class="class-behaves" v-show="currentType!=2">
            <a-spin :spinning="main" :tip="tipsText">
              <div class="class-behave">
                <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}被动行为</span>
                <div class="flex-row justify-between ml-20 mr-20">
                  <div class="flex-col">
                    <span class="behave_title blue"> 阅读行为</span>
                    <span class="behave_content"> {{ readTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title green"> 听诵读</span>
                    <span class="behave_content">{{ radioTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title yellow"> 视频学习</span>
                    <span class="behave_content"> {{ videoTotal }}</span>
                  </div>
                </div>
                <div class="class-echarts" id="main" v-if="!mainEmpty"></div>
                <a-empty v-if="mainEmpty"/>
              </div>
            </a-spin>
            <a-spin :spinning="create" :tip="tipsText">
              <div class="class-behave">
                <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}构建行为</span>
                <div class="flex-row justify-between ml-20 mr-20">
                  <div class="flex-col">
                    <span class="behave_title blue">任务活动数量</span>
                    <span class="behave_content">  {{ activityTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title green"> 任务活动获得星星数量</span>
                    <span class="behave_content"> {{ starTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title yellow"> 主观题数量</span>
                    <span class="behave_content">  {{ subjectiveTotal }}</span>
                  </div>
                </div>
                <div class="class-echarts" id="create" v-if="!createEmpty"></div>
                <a-empty v-if="createEmpty"/>
              </div>

            </a-spin>
            <a-spin :spinning="positive" :tip="tipsText">
              <div class="class-behave">
                <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}主动行为</span>
                <div class="flex-row justify-between ml-20 mr-20">
                  <div class="flex-col">
                    <span class="behave_title blue"> 标注</span>
                    <span class="behave_content">  {{ dimensionTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title green"> 朗读</span>
                    <span class="behave_content"> {{ readingTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title yellow"> 完成客观题数量</span>
                    <span class="behave_content">  {{ objectiveTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title  purple"> 正确客观题数量</span>
                    <span class="behave_content">  {{ objectiveCorrectTotal }}</span>
                  </div>
                </div>
                <div class="class-echarts" id="positive" v-if="!positiveEmpty"></div>
                <a-empty v-if="positiveEmpty"/>
              </div>
            </a-spin>
            <a-spin :spinning="interaction" :tip="tipsText">
              <div class="class-behave">
                <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}交互行为</span>
                <div class="flex-row justify-between ml-20 mr-20">
                  <div class="flex-col">
                    <span class="behave_title blue"> 评论</span>
                    <span class="behave_content">  {{ commentTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title green"> 提问</span>
                    <span class="behave_content"> {{ askTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title yellow"> 点赞</span>
                    <span class="behave_content">  {{ praiseTotal }}</span>
                  </div>
                </div>
                <div class="class-echarts" id="interaction" v-if="!interactionEmpty"></div>
                <a-empty v-if="interactionEmpty"/>
              </div>
            </a-spin>
          </div>
          <div class="class-jiaohu flex-col" v-show="currentType==2">
            <div class="justify-between">
              <span>交互关系</span>
              <div class="classSpan">导出</div>
            </div>
            <div class="class-echarts-3" id="main1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { decryptDes } from 'utils/crypto.js'
import axios from 'axios'
import format from '../../utils/format.js'
import { getCompareOption } from '../../utils/echartsOption'

export default {
  name: 'HomeCourseComparision',
  props: {
    // 任务类型
    params: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      classShow: true,
      stuULShow: false,
      showRelDiv: false,
      bookList: [
        { name: '必修上', key: 0 },
        { name: '必修上1', key: 1 },
        { name: '必修上2', key: 2 },
        { name: '必修上3', key: 3 }
      ],
      current: 0, // 课本年级
      classType: [
        { name: '查看班级表现', key: 1 },
        { name: '查看学生表现', key: 2 }
      ],
      currentType: 0, // 班级分类
      classList: [{ name: '班级1', id: 0 }],

      isPad: true,
      becurrent: 0,
      studentShow: false,
      classCheckedList: [], // 班级或学生选择
      beaviourCheckedList: [0, 1], // 班级表现选择
      studentModal: false, // 全部学生列表
      classModal: false, // 全部班级列表
      relClassId: '',
      downBtnLoading: false,
      classSelect: [],
      defautlClassName: [], // 班级默认选择
      studentList: [],
      plainOptions: [], // 选择的学生
      indeterminate: true, // 动画
      checkedList: [],
      studentsCheckedList: [],
      newStudentList: [],
      bookId: '', // 默认
      type: 1,
      classIds: [],
      studentIds: [],
      dataType: 'read', // 行为类型
      columns: [],
      tableData: [],
      userId: '',
      color: ['#FF5F4C', '#FFAB45', '#32C1FF', '#FFD300', '#17CE74', '#8E83E7', '#578EEF'],
      behaviorArray: [],
      access_token: '',
      loading: false,

      showLine: true,
      showIcon: false,
      classCurrent: 0,
      options: [],

      studentListCheck: [], // 选中的学生列表
      isDivVisible: false,
      readTotal: 0,
      radioTotal: 0,
      videoTotal: 0,
      dimensionTotal: 0,
      readingTotal: 0,
      objectiveTotal: 0,
      objectiveCorrectTotal: 0,
      activityTotal: 0,
      starTotal: 0,
      subjectiveTotal: 0,
      askTotal: 0,
      commentTotal: 0,
      praiseTotal: 0,
      main: true,
      create: true,
      positive: true,
      interaction: true,
      mainEmpty: true,
      createEmpty: true,
      positiveEmpty: true,
      interactionEmpty: true,
      learntype: true,
      styleIds: [],
      styelNames: ['课程1', '课程2', '课程3', '课程4', '课程5'],
      styleId1: {},
      styleId2: {},
      styleId3: {},
      styleId4: {},
      styleId5: {},
      userNames: ['学生1', '学生2', '学生3', '学生4'],
      classIdBiaoXian: [],
      classNames2: ['班级1', '班级2', '班级3', '班级4'],
      tipsText: '加载中',
      userIds: [],
      bagColor: ['#e3f9fd', '#fcefe8', '#f2ecde', '#e0f0e9', '#e3f9fd', '#fcefe8']
    }
  },
  mounted () {
    this.loginInit()
  },
  methods: {
    goHistory () {
      this.$router.push({ name: 'PhoneStudentsDraw' })
    },
    loginInit () {
      // console.log('params', this.params)
      // const parameter = decryptDes('5ecfd021795f9a10245329b509849e106cc9d2d77acd05ad4a6c3c1761d3d48e3b226ed0bd4f3a0d8912aeef0ae53a44b7ea35859aff038bdd69909edc94c9029d1c189272ce8bf0')
      if (this.$route.path.indexOf('/accompanyStudy') === 0) {
        // 网页端
        //  console.log('isPad', '网页端')
        this.isPad = false
        this.userId = this.$getUserInfo().id
        this.access_token = localStorage.getItem('access_token')
      } else {
        // 移动端
        //  console.log('isPad', '移动端')
        this.access_token = localStorage.getItem('access_token')
        this.userId = localStorage.getItem('userId')
      }
      //  console.log('access_token', this.access_token)
      //  console.log('userId', this.userId)
      this.bookSimpleList()
      this.getClassList()
      this.getStudentList()
      this.getEchartsData()
    },
    bookSimpleList () {
      const _this = this
      _this
        .$fetch({
          url: _this.$baseUrl + 'ebook/teacher/statistics2/bookStyleList',
          body: {
            token: _this.access_token
          }
        })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.options = res.resultData
            _this.bookId = res.resultData[0].id
          }
        })
    },
    getClassList () {
      const _this = this
      _this
        .$fetch({
          url: _this.$baseUrl + 'ebook/teacher/statistics/listClass',
          body: {
            token: _this.access_token,
            userId: _this.userId
          }
        })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.classList = res.resultData
            _this.classCheckedList.push(res.resultData[0].id)
            _this.classIds = _this.classCheckedList
            _this.defautlClassName.push(res.resultData[0].className)
          }
        })
    },
    getStudentList () {
      const _this = this
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics/listClassStu',
        body: {
          token: _this.access_token,
          userId: _this.userId
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          _this.studentList = res.resultData
          _this.newStudentList = res.resultData[0].users
          _this.defautlClassName.push(res.resultData[0].className)
        }
      })
    },

    getStyleIds () {
      const filteres = [this.styleId1, this.styleId2, this.styleId3, this.styleId4, this.styleId5]
      const filteredIds = filteres
        .filter(item => item && item.id && item.id.trim() !== '') // 筛选出 id 不为空的对象
        .map(item => item.id) // 提取满足条件的对象的 id 字段
      this.styleIds = filteredIds

      const filteredNames = filteres
        .filter(item => item && item.displayName && item.displayName.trim() !== '') // 筛选出 id 不为空的对象
        .map(item => item.displayName) // 提取满足条件的对象的 id 字段
      this.styelNames = filteredNames
      //  console.log('styleIds', this.styleIds)
      this.getEchartsData()
    },
    onCascaderChange1 (value, selectedOptions) {
      this.styleId1 = selectedOptions[2]
      this.getStyleIds()
      //  console.log('styleId1', this.styleId1)
    },
    onCascaderChange2 (value, selectedOptions) {
      this.styleId2 = selectedOptions[2]
      this.getStyleIds()
      //  console.log('styleId2', this.styleId2)
    },
    onCascaderChange3 (value, selectedOptions) {
      this.styleId3 = selectedOptions[2]
      this.getStyleIds()
      //  console.log('styleId3', this.styleId3)
    },
    onCascaderChange4 (value, selectedOptions) {
      this.styleId4 = selectedOptions[2]
      this.getStyleIds()
      //  console.log('styleId4', this.styleId4)
    },
    onCascaderChange5 (value, selectedOptions) {
      this.styleId5 = selectedOptions[2]
      this.getStyleIds()
      //  console.log('styleId5', this.styleId5)
    },
    displayRender ({ labels }) {
      return labels[labels.length - 1]
    },
    enterDown () {
      // 导出
      this.downBtnLoading = true
    },
    async downloadExcel () {
      try {
        if (this.classIdBiaoXian.length == 0) {
          this.$message.error('未选择班级')
          return
        }
        if (this.styleIds.length == 0) {
          this.$message.error('未选择课程')
          return
        }
        let exportType = ''
        if (this.currentType === 0) {
          // 班级行为表现--班级课文
          exportType = 'classesStyles'
        } else {
          // 用户行为表现--用户课文
          exportType = 'usersStyles'
        }
        this.downBtnLoading = true
        const styleIds = []
        styleIds.push(this.styleId)
        const url1 = this.$httpConfig.exportExcel
        const response = await axios.post(url1, {
          // POST 请求的参数
          access_token: this.access_token,
          userIds: this.userIds,
          styleId: this.styleId,
          styleIds: this.styleIds,
          classIds: this.classIdBiaoXian,
          exportType: exportType
        }, {
          responseType: 'blob' // 设置响应类型为二进制流
        })
        // 创建一个 Blob 对象，并设置 MIME 类型
        const blob = new Blob([response.data], { type: 'application/octet-stream' })
        // 创建下载链接
        const url = window.URL.createObjectURL(blob)
        // 创建一个 <a> 元素，设置属性并模拟点击下载
        const link = document.createElement('a')
        link.href = url

        if (this.currentType === 0) {
          // 班级行为表现
          // 班级课文
          link.setAttribute('download', '【课程对比-班级表现】ICAP统计结果' + format.formatDayTime(new Date().valueOf()) + '.zip') // 设置下载文件名
        } else {
          // 用户行为表现
          // 用户课文
          link.setAttribute('download', '【课程对比-学生表现】ICAP统计结果' + format.formatDayTime(new Date().valueOf()) + '.zip') // 设置下载文件名
        }
        document.body.appendChild(link)
        link.click()

        // 清理资源
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.downBtnLoading = false
      } catch (error) {
        console.error('Error downloading Excel file:', error)
        // 处理错误
        this.$message.error('发生错误')
        this.downBtnLoading = false
      }
    },
    onTypeChange (e) {
      // 表现选择变化
      this.currentType = e
      this.getEchartsData()
      //  console.log('表现选择变化', e)
    },
    classChange (e) {
      // 选择的班级
      //  console.log('classChange', e)
      this.classIdBiaoXian = e.map(item => item.id)
      this.className2s = e.map(item => item.className)
      //  console.log('classChange', this.classIdBiaoXian)
      if (this.currentType === 1) {
        // 选择学生
        this.getStudentData()
      } else {
        this.userIds = []
        this.userNames = []
      }
      this.getEchartsData()
    },
    getStudentData () {
      // 筛选选中班级的学生
      const filteredStudents = this.studentList.filter(student => this.classIdBiaoXian.includes(student.id) && student.users !== null)
      this.studentListCheck = filteredStudents.flatMap(student => student.users)
      //  console.log('studentListCheck', this.studentListCheck)
      //  console.log('studentList', this.studentList)
      //  console.log('classIds', this.classIds)
      // 从 userIds 中移除不存在于 studentListCheck 中的 userId
      this.userIds = this.userIds.filter(userId => this.studentListCheck.find(student => student.userId === userId))
      this.userNames = this.userNames.filter(userName => this.studentListCheck.find(student => student.userName === userName))
      //  console.log('userIds', this.userIds)
      //  console.log('userNames', this.userNames)
      //  console.log('styleIds', this.styleIds)
    },
    studentChange (e) {
      // 选择的学生
      //  console.log(e)
      this.userIds = e.map(item => item.userId)
      this.userNames = e.map(item => item.userName)

      this.getEchartsData()
    },
    studentShowMore () {
      // 学生显示全部
      const filteredStudents = this.studentList.filter(student => this.classIdBiaoXian.includes(student.id) && student.users !== null)
      this.studentListCheck = filteredStudents.flatMap(student => student.users)
    },
    getEchartsData () {
      if (this.currentType === 0) {
        this.main = true
        this.create = true
        this.positive = true
        this.interaction = true
        // 班级行为表现
        //  console.log('getEchartsData-0', this.classIdBiaoXian)
        //  console.log('getEchartsData-0', this.styleIds)
        this.tipsText = this.classIdBiaoXian.length > 0 ? (this.styleIds.length > 0 ? '加载中' : '未选择课程') : '未选择班级'

        this.classStyleStatistics4Active()
        this.classStyleStatistics4Passivity()
        this.classStyleStatistics4Interaction()
        this.classStyleStatistics4Create()
      } else if (this.currentType === 1) {
        // 学生行为表现
        this.tipsText = this.userIds.length > 0 ? (this.styleIds.length > 0 ? '加载中' : '未选择课程') : '未选择学生'
        this.main = true
        this.create = true
        this.positive = true
        this.interaction = true
        this.getStudentData()
        this.userStyleStatistics4Active()
        this.userStyleStatistics4Passivity()
        this.userStyleStatistics4Interaction()
        this.userStyleStatistics4Create()
      }
    },

    classStyleStatistics4Passivity () {
      // 班级表现被动行为（课程）
      const _this = this
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics2/classStyleStatistics4Passivity',
        body: {
          token: _this.access_token,
          styleIds: this.styleIds,
          classIds: this.classIdBiaoXian
          // styleIds: ["2", "3"],
          // classIds: ["030230ae30154dc79da75059e41bc506", "3b351a06ccd04b21a30f6214ac65b864"],
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.main = false

          // 将毫秒转化为00:00:00的格式
          this.readTotal = format.formattedTime(data.readTotal)
          this.radioTotal = format.formattedTime(data.radioTotal)
          this.videoTotal = format.formattedTime(data.videoTotal)

          this.mainEmpty = !data || (this.readTotal === 0.0 && this.radioTotal === 0.0 && this.videoTotal === 0.0)

          const readArray = data.readArray.map(seconds => (seconds / 3600).toFixed(1))
          const radioArray = data.radioArray.map(seconds => (seconds / 3600).toFixed(1))
          const videoArray = data.videoArray.map(seconds => (seconds / 3600).toFixed(1))
          const dataSeries = [
            { key: '阅读行为', value: readArray },
            { key: '听诵读', value: radioArray },
            { key: '视频学习', value: videoArray }
          ]
          const option = getCompareOption(dataSeries, this.styelNames, this.className2s, true)
          this.showChart('main', option)
        }
      })
    },
    classStyleStatistics4Active () {
      // 班级表现主动行为（课程）
      const _this = this
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics2/classStyleStatistics4Active',
        body: {
          token: _this.access_token,
          styleIds: this.styleIds,
          classIds: this.classIdBiaoXian
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.positive = false
          this.positiveEmpty = !data

          this.dimensionTotal = data.dimensionTotal
          this.readingTotal = data.readingTotal
          this.objectiveTotal = data.objectiveTotal
          this.objectiveCorrectTotal = data.objectiveCorrectTotal

          const dataSeries = [
            { key: '标注', value: data.dimensionArray },
            { key: '朗读', value: data.readingArray },
            { key: '完成客观题数量', value: data.objectiveArray },
            { key: '正确客观题数量', value: data.objectiveCorrectArray }
          ]
          const option = getCompareOption(dataSeries, this.styelNames, this.className2s)
          this.showChart('positive', option)
        }
      })
    },
    classStyleStatistics4Create () {
      // 班级表现构建行为（课程）
      const _this = this
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics2/classStyleStatistics4Create',
        body: {
          token: _this.access_token,
          styleIds: this.styleIds,
          classIds: this.classIdBiaoXian
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.create = false
          this.createEmpty = !data

          this.activityTotal = data.activityTotal
          this.starTotal = data.starTotal
          this.subjectiveTotal = data.subjectiveTotal

          const dataSeries = [
            { key: '任务下活动数量', value: data.activityArray },
            { key: '任务下活动所获得星星数量', value: data.starArray },
            { key: '主观题数量', value: data.subjectiveArray }
          ]
          const option = getCompareOption(dataSeries, this.styelNames, this.className2s)
          this.showChart('create', option)
        }
      })
    },
    classStyleStatistics4Interaction () {
      // 班级表现互动行为（课程）
      const _this = this
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics2/classStyleStatistics4Interaction',
        body: {
          token: _this.access_token,
          styleIds: this.styleIds,
          classIds: this.classIdBiaoXian
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.interaction = false
          this.interactionEmpty = !data

          this.askTotal = data.askTotal || 0
          this.commentTotal = data.commentTotal || 0
          this.praiseTotal = data.praiseTotal || 0

          const dataSeries = [
            { key: '评论', value: data.commentArray },
            { key: '提问', value: data.askArray },
            { key: '点赞', value: data.praiseArray }
          ]
          const option = getCompareOption(dataSeries, this.styelNames, this.className2s)
          this.showChart('interaction', option)
        }
      })
    },

    userStyleStatistics4Passivity () {
      // 班级表现被动行为（课程）
      const _this = this
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics2/userStyleStatistics4Passivity',
        body: {
          token: _this.access_token,
          styleIds: this.styleIds,
          userIds: this.userIds
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.main = false

          // 将毫秒转化为00:00:00的格式
          this.readTotal = format.formattedTime(data.readTotal)
          this.radioTotal = format.formattedTime(data.radioTotal)
          this.videoTotal = format.formattedTime(data.videoTotal)

          this.mainEmpty = !data || (this.readTotal === 0.0 && this.radioTotal === 0.0 && this.videoTotal === 0.0)

          const readArray = data.readArray.map(seconds => (seconds / 3600).toFixed(1))
          const radioArray = data.radioArray.map(seconds => (seconds / 3600).toFixed(1))
          const videoArray = data.videoArray.map(seconds => (seconds / 3600).toFixed(1))
          const dataSeries = [
            { key: '阅读行为', value: readArray },
            { key: '听诵读', value: radioArray },
            { key: '视频学习', value: videoArray }
          ]
          const option = getCompareOption(dataSeries, this.styelNames, this.userNames, true)
          this.showChart('main', option)
        }
      })
    },
    userStyleStatistics4Active () {
      // 班级表现主动行为（课程）
      const _this = this
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics2/userStyleStatistics4Active',
        body: {
          token: _this.access_token,
          styleIds: this.styleIds,
          userIds: this.userIds
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.positive = false
          this.positiveEmpty = !(res.resultData !== null && res.resultData !== '')

          this.dimensionTotal = data.dimensionTotal
          this.readingTotal = data.readingTotal
          this.objectiveTotal = data.objectiveTotal
          this.objectiveCorrectTotal = data.objectiveCorrectTotal

          const dataSeries = [
            { key: '标注', value: data.dimensionArray },
            { key: '朗读', value: data.readingArray },
            { key: '完成客观题数量', value: data.objectiveArray },
            { key: '正确客观题数量', value: data.objectiveCorrectArray }
          ]
          const option = getCompareOption(dataSeries, this.styelNames, this.userNames)
          this.showChart('positive', option)
        }
      })
    },
    userStyleStatistics4Create () {
      // 班级表现构建行为（课程）
      const _this = this
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics2/userStyleStatistics4Create',
        body: {
          token: _this.access_token,
          styleIds: this.styleIds,
          userIds: this.userIds
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.create = false
          this.createEmpty = !data

          this.activityTotal = data.activityTotal
          this.starTotal = data.starTotal
          this.subjectiveTotal = data.subjectiveTotal

          const dataSeries = [
            { key: '任务下活动数量', value: data.activityArray },
            { key: '任务下活动所获得星星数量', value: data.starArray },
            { key: '主观题数量', value: data.subjectiveArray }
          ]
          const option = getCompareOption(dataSeries, this.styelNames, this.userNames)
          this.showChart('create', option)
        }
      })
    },
    userStyleStatistics4Interaction () {
      // 班级表现互动行为（课程）
      const _this = this
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics2/userStyleStatistics4Interaction',
        body: {
          token: _this.access_token,
          styleIds: this.styleIds,
          userIds: this.userIds
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.interaction = false
          this.interactionEmpty = !data

          this.askTotal = data.askTotal || 0
          this.commentTotal = data.commentTotal || 0
          this.praiseTotal = data.praiseTotal || 0

          const dataSeries = [
            { key: '评论', value: data.commentArray },
            { key: '提问', value: data.askArray },
            { key: '点赞', value: data.praiseArray }
          ]
          const option = getCompareOption(dataSeries, this.styelNames, this.userNames)
          this.showChart('interaction', option)
        }
      })
    },
    showChart (containerId, option) {
      setTimeout(() => {
        try {
          const chartStar = this.$echarts.init(document.getElementById(containerId))
          chartStar.setOption(option)
          chartStar.resize()
        } catch (error) {
        }
      }, 200)
    }

  }
}
</script>
<style lang="less" scoped>
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

.phone {
  width: 100vw;

  .breadcrumb {
    font-size: 16px;
  }

  .class-tree {
    background: #FFFFFF;
    width: 200px;
    height: 115vh;
    margin: 20px 20px 0 20px;
    border-radius: 10px;
  }

  .class-detail {
    margin-right: 20px;
    margin-left: 20px;

    .classAct {
      padding: 6px 15px;
      color: #867D7B;
      background: #F1F0F0;
      font-size: 14px;
      cursor: pointer;
      margin-right: 10px;
      border-radius: 4px;
    }

    .classSpan {
      padding: 6px 10px;
      color: #fff;
      background: @primary-color;
      font-size: 14px;
      cursor: pointer;
      margin-right: 10px;
      border-radius: 4px;
    }

    .class-option {
      background: #fff;
      margin-top: 15px;

      padding: 20px 10px 10px 10px;
      border-radius: 10px;

      .class-option-content {
        font-size: 16px;
        color: #000;

        .class-option-empty {
          font-size: 14px;
          text-align: center;
        }
      }

      .class-option-title {
        width: 80px;
        font-size: 14px
      }

      .class-option-more {
        font-size: 14px;
        text-align: center;
        margin-top: 40px;
      }
    }

    .class-behaves {

      .class-behave {
        background: #fff;
        margin-top: 20px;
        padding: 30px 10px 10px 10px;
        border-radius: 10px;

        .class-type {
          font-size: 14px;
          font-weight: bold
        }

        .behave_title {
          margin-top: 10px;
          font-size: 13px;
          position: relative;
          display: inline-block;
          margin-right: 10px; /* 调整颜色块与文字之间的间距 */
          z-index: 1;
        }

        .behave_title::before {
          content: '';
          position: absolute;
          left: -10px; /* 调整颜色块的位置 */
          top: 50%;
          transform: translateY(-50%);
          width: 5px; /* 设置颜色块的宽度 */
          height: 12px; /* 设置颜色块的高度 */
          z-index: -1;
        }

        .yellow::before {
          background-color: #32C1FF; /* 设置黄色颜色块的背景颜色 */
        }

        .purple::before {
          background-color: #FFD300; /* 设置紫色颜色块的背景颜色 */
        }

        .blue::before {
          //    color: ['#FF5F4C', '#FFAB45', '#32C1FF', '#FFD300', '#17CE74', '#8E83E7', '#578EEF'],
          background-color: #FF5F4C; /* 设置蓝色颜色块的背景颜色 */
        }

        .green::before {
          background-color: #FFAB45; /* 设置绿色颜色块的背景颜色 */
        }

        .behave_content {
          margin-top: 5px;
          font-size: 13px;
          text-align: center; /* 水平居中 */
        }

        .class-echarts {
          margin-top: 20px;
          max-width: 1200px;
          min-height: 250px;
          margin-top: 20px;
          background: rgba(0, 0, 0, 0.05);
          border-radius: 10px;
        }

        .class-echarts-2 {
          margin-top: 20px;
          max-width: 1200px;
          min-height: 560px;
          margin-top: 20px;
          background: #e6f8f3;
          border-radius: 10px;
        }
      }

    }

    .class-jiaohu {
      background: #fff;
      margin-top: 20px;
      padding: 30px 10px 10px 10px;
      border-radius: 10px;

      .class-echarts-3 {
        margin-top: 20px;
        max-width: 1200px;
        min-height: 560px;
        margin-top: 20px;
        background: #DBD1CD;
        border-radius: 10px;
      }
    }
  }

  /deep/ .ant-checkbox-wrapper {
    //width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /deep/ .ant-radio-wrapper {
    font-size: 14px;
  }

  /deep/ .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0px;
  }

  /deep/ .ant-checkbox-wrapper {
    font-size: 14px;
    color: #000;
  }

  /deep/ .ant-tree li .ant-tree-node-content-wrapper {
    width: 130px; /* 设置树节点的宽度 */
    white-space: nowrap; /* 确保文本在一行内显示 */
    overflow: hidden; /* 隐藏超出部分的文本 */
    text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
  }

  /deep/ .ant-divider-horizontal {
    margin: 10px 0;
  }

  /deep/ .ant-empty {
    margin-top: 20px;
    max-width: 1200px;
    min-height: 250px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    align-content: center;
  }

  ::-webkit-scrollbar-track-piece {
    //滚动条凹槽的颜色，还可以设置边框属性
    background-color: #f8f8f8;
  }

  ::-webkit-scrollbar {
    //滚动条的宽度
    width: 9px;
    height: 9px;
  }

  ::-webkit-scrollbar-thumb {
    //滚动条的设置
    background-color: #dddddd;
    background-clip: padding-box;
    min-height: 28px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #bbb;
  }

}

.home {

  .breadcrumb {
    font-size: 16px;
  }

  .class-tree {
    background: #FFFFFF;
    width: 200px;
    height: 115vh;
    margin: 20px 20px 0 20px;
    border-radius: 10px;
  }

  .class-detail {
    margin-right: 40px;
    margin-left: 40px;

    .classAct {
      padding: 6px 15px;
      color: #867D7B;
      background: #F1F0F0;
      font-size: 14px;
      cursor: pointer;
      margin-right: 10px;
      border-radius: 4px;
    }

    .classSpan {
      padding: 6px 10px;
      color: #fff;
      background: @primary-color;
      font-size: 14px;
      cursor: pointer;
      margin-right: 10px;
      border-radius: 4px;
    }

    .class-option {
      background: #fff;
      margin-top: 20px;

      padding: 20px 10px 10px 10px;
      border-radius: 10px;

      .class-option-content {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #000;

        .class-option-empty {
          font-size: 14px;
          text-align: center;
        }
      }

      .class-option-title {
        width: 90px;
        font-size: 14px
      }

      .class-option-more {
        font-size: 14px;
        text-align: center;
        margin-top: 40px;
      }
    }

    .class-behaves {

      .class-behave {
        background: #fff;
        margin-top: 20px;
        padding: 30px 10px 10px 10px;
        border-radius: 10px;

        .class-type {
          font-size: 14px;
          font-weight: bold
        }

        .behave_title {
          margin-top: 10px;
          font-size: 13px;
          position: relative;
          display: inline-block;
          margin-right: 10px; /* 调整颜色块与文字之间的间距 */
          z-index: 1;
        }

        .behave_title::before {
          content: '';
          position: absolute;
          left: -10px; /* 调整颜色块的位置 */
          top: 50%;
          transform: translateY(-50%);
          width: 5px; /* 设置颜色块的宽度 */
          height: 12px; /* 设置颜色块的高度 */
          z-index: -1;
        }

        .yellow::before {
          background-color: #32C1FF; /* 设置黄色颜色块的背景颜色 */
        }

        .purple::before {
          background-color: #FFD300; /* 设置紫色颜色块的背景颜色 */
        }

        .blue::before {
          //    color: ['#FF5F4C', '#FFAB45', '#32C1FF', '#FFD300', '#17CE74', '#8E83E7', '#578EEF'],
          background-color: #FF5F4C; /* 设置蓝色颜色块的背景颜色 */
        }

        .green::before {
          background-color: #FFAB45; /* 设置绿色颜色块的背景颜色 */
        }

        .behave_content {
          margin-top: 5px;
          font-size: 13px;
          text-align: center; /* 水平居中 */
        }

        .class-echarts {
          margin-top: 20px;
          max-width: 1200px;
          min-height: 200px;
          margin-top: 20px;
          background: rgba(0, 0, 0, 0.05);
          border-radius: 10px;
        }

        .class-echarts-2 {
          margin-top: 20px;
          max-width: 1200px;
          min-height: 560px;
          margin-top: 20px;
          background: #e6f8f3;
          border-radius: 10px;
        }
      }

    }

    .class-jiaohu {
      background: #fff;
      margin-top: 20px;
      padding: 30px 10px 10px 10px;
      border-radius: 10px;

      .class-echarts-3 {
        margin-top: 20px;
        max-width: 1200px;
        min-height: 560px;
        margin-top: 20px;
        background: #DBD1CD;
        border-radius: 10px;
      }
    }
  }

  /deep/ .ant-checkbox-group {
    max-width: 90vw;
  }

  /deep/ .ant-checkbox-wrapper {
    // width: 150px;
    min-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /deep/ .ant-radio-wrapper {
    font-size: 14px;
  }

  /deep/ .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0px;
  }

  /deep/ .ant-checkbox-wrapper {
    font-size: 14px;
    color: #000;
  }

  /deep/ .ant-tree li .ant-tree-node-content-wrapper {
    width: 130px; /* 设置树节点的宽度 */
    white-space: nowrap; /* 确保文本在一行内显示 */
    overflow: hidden; /* 隐藏超出部分的文本 */
    text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
  }

  /deep/ .ant-divider-horizontal {
    margin: 10px 0;
  }

  /deep/ .ant-empty {
    margin-top: 20px;
    max-width: 1200px;
    min-height: 200px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    align-content: center;
  }

  ::-webkit-scrollbar-track-piece {
    //滚动条凹槽的颜色，还可以设置边框属性
    background-color: #f8f8f8;
  }

  ::-webkit-scrollbar {
    //滚动条的宽度
    width: 9px;
    height: 9px;
  }

  ::-webkit-scrollbar-thumb {
    //滚动条的设置
    background-color: #dddddd;
    background-clip: padding-box;
    min-height: 28px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #bbb;
  }

}

</style>
